<template>
  <div>
    <div
      class="upload"
      @click="upload"
      id="drop-area"
      @dragover.prevent
      @drop.prevent="handleDrop"
      @dragenter="highlight"
      @dragleave="unhighlight"
    >
      <div v-if="!uploadStaus.ing && !uploadStaus.end" class="up-model">
        <p><img src="@/assets/icons/icon_sc@2x.png" alt="" class="up-icon" /></p>
        <p>{{ $t('massUpload.dragFile') }}</p>
      </div>
      <div v-else @click="stopBubbling" class="stopBubbling">
        <template v-if="!uploadStaus.end">
          <a-button type="link" @click.stop="handleOk" class="cancel">{{ $t('massUpload.cancel') }}</a-button>
          <img class="loading-icon" src="@/assets/img/loading.png" alt="" />
          <h4 class="success-f-clolor">({{ successNum }} / {{ fileList.length }}) {{ $t('massUpload.uploading') }} {{ uploadStaus.progress }}%</h4>
        </template>
        <template v-else>
          <div v-if="!uploadStaus.fail && uploadStaus.ok" class="success">
            <a-icon type="check-circle" />
            <h4>{{ $t('massUpload.success') }}</h4>
            <a-button type="primary" @click.stop="handleOk">{{ $t('massUpload.know') }}</a-button>
          </div>
          <div v-else-if="uploadStaus.fail && uploadStaus.ok" class="success warning">
            <a-icon type="exclamation-circle" />
            <h4>{{ $t('massUpload.partialFailure') }}</h4>
            <a-button type="primary" @click.stop="failureDetails">{{ $t('massUpload.failureDetails') }}</a-button>
          </div>
          <div v-else class="success error">
            <a-icon type="close-circle" />
            <h4>{{ $t('massUpload.failure') }}</h4>
            <a-button type="primary" @click.stop="failureDetails">{{ $t('massUpload.failureDetails') }}</a-button>
          </div>
        </template>
      </div>
      <input ref="fileInput" type="file" multiple :accept="accept" style="display: none;" @change="inputChange" />
    </div>
    <div class="tip">
      <span>{{ $t('massUpload.supportedFileTypes') }}:</span>
      <a-tooltip placement="topLeft" v-for="item in tipList" :key="item.desc" :arrowPointAtCenter="true">
        <template slot="title">
          <span>{{ item.desc }}</span>
        </template>
        <img :src="item.img" alt="" class="list" />
      </a-tooltip>
      <span>{{ item }}</span>
    </div>
    <FailureDetails ref="FailureDetails" :data="failFileList" @changeMassUploadvisible="changeMassUploadvisible" />
    <canvas ref="canvas" style="display:none;"></canvas>
  </div>
</template>

<script>
import OSS from 'ali-oss'
import SparkMD5 from 'spark-md5'
import { OSSConfig, md5Check, utilReport } from '@/api/common'
import FailureDetails from './FailureDetails.vue'
import { batchUpload } from '@/api/lesson'

const nameMap = {
  文本类: 'text',
  图片类: 'image',
  音频类: 'audio',
  视频类: 'video',
  '3D模型': 'model',
  软件: 'software'
}
export default {
  name: 'MassUpload',
  components: {
    FailureDetails
  },
  data() {
    return {
      visible: false,
      fileList: [],
      successNum: 0,
      uploadStaus: {
        ok: false,
        fail: false,
        ing: false,
        end: false,
        progress: 0,
        isUploading: true
      },
      isHighlighted: false,
      failFileList: [],
      batchFileList: [],
      accept: '.doc,.docx,.xls,.xlsx,.pdf,.ppt,.pptx,.gif,.jpeg,.png,.jpg,.mp3,.wav,.mp4,.FBX,.GLB',
      tipList: [
        {
          img: require('@/assets/icons/icon_pdf.png'),
          desc: 'pdf'
        },
        {
          img: require('@/assets/icons/icon_word.png'),
          desc: 'doc、docx'
        },
        {
          img: require('@/assets/icons/icon_ppt.png'),
          desc: 'ppt、pptx'
        },
        {
          img: require('@/assets/icons/icon_xlsx.png'),
          desc: 'xls、xlsx'
        },
        {
          img: require('@/assets/icons/icon_tupian.png'),
          desc: 'gif、jpeg、png、jpg'
        },
        {
          img: require('@/assets/icons/icon_shiping.png'),
          desc: 'mp4'
        },
        {
          img: require('@/assets/icons/icon_audio.png'),
          desc: 'mp3、wav'
        },
        {
          img: require('@/assets/icons/icon_model.png'),
          desc: 'fbx、glb'
        }
      ]
    }
  },
  methods: {
    showModal() {
      this.initData()
    },
    handleOk() {
      this.uploadStaus.ing = false
      this.uploadStaus.isUploading = false
      this.$emit('hideVisible')
    },
    initData() {
      this.successNum = 0
      this.uploadStaus.ok = false
      this.uploadStaus.fail = false
      this.fileList = []
      this.batchFileList = []
      this.uploadStaus.end = false
      this.uploadStaus.progress = 0
      this.uploadStaus.isUploading = true
    },
    upload() {
      this.$refs.fileInput.click()
    },
    inputChange(e, files) {
      console.log('e, files ----->', e, files)
      const _this = this
      const resourceMap = {
        doc: '文本类',
        docx: '文本类',
        xls: '文本类',
        xlsx: '文本类',
        pdf: '文本类',
        ppt: '文本类',
        pptx: '文本类',
        gif: '图片类',
        jpeg: '图片类',
        png: '图片类',
        jpg: '图片类',
        mp3: '音频类',
        wav: '音频类',
        mp4: '视频类',
        fbx: '3D模型',
        glb: '3D模型',
        zip: '软件',
        exe: '软件'
      }
      function getFileExtension(filename) {
        // 使用正则表达式匹配最后一个点后面的部分
        const match = filename.match(/\.([^.]+)$/)
        return match ? match[1].toLowerCase() : null
      }
      function setTips(file, msg = '文件过大，上传失败') {
        file.flag = false
        file.msg = msg
        _this.uploadStaus.fail = true
      }
      this.uploadStaus.ing = true
      // 初始化
      this.initData()
      // 获取文件列表
      try {
        this.fileList = Array.from(!e ? files : e.target.files).slice(0, 100)
        if (this.fileList.length === 0 || !this.uploadStaus.isUploading) return
        this.fileList.forEach((file, inx) => {
          file.index = inx + 1
          file.isUpload = true
          file.fileType = resourceMap[getFileExtension(file.name)] || '未知类型'
          switch (resourceMap[getFileExtension(file.name)]) {
            case '文本类':
              if (file.size > 1024 * 1024 * 1024 * 1) {
                setTips(file)
              }
              break
            case '图片类':
              if (file.size > 1024 * 1024 * 200) {
                setTips(file)
              }
              break
            case '音频类':
              if (file.size > 1024 * 1024 * 1024 * 1) {
                setTips(file)
              }
              break
            case '视频类':
              if (file.size > 1024 * 1024 * 1024 * 2) {
                setTips(file)
              }
              break
            case '3D模型':
              if (file.size > 1024 * 1024 * 1024 * 2) {
                setTips(file)
              }
              break
            case '软件':
              if (file.size > 1024 * 1024 * 1024 * 2) {
                setTips(file)
              }
              break
          }
          if (!resourceMap[getFileExtension(file.name)]) {
            setTips(file, '暂不支持上传该类资源')
          }
        })
        this.packetUpload()
      } catch (e) {
        console.warn('批量上传失败', e)
      }
    },
    async packetUpload() {
      let allSuccess = false
      const batchSize = 10

      this.uploadStaus.progress = 0
      const uploadFileList = this.fileList.filter(item => item.flag !== false)
      // 文件分组上传
      for (let i = 0; i < uploadFileList.length; i += batchSize) {
        if (this.uploadStaus.isUploading === false) break
        const batch = uploadFileList.slice(i, i + batchSize)
        const success = await this.uploadBatch(batch)
        if (!success) {
          console.warn(`Batch ${Math.floor(i / batchSize) + 1} failed. Retrying...`)
        }
      }
      if (this.uploadStaus.isUploading === false) return
      // 状态处理
      if (!this.uploadStaus.fail && this.uploadStaus.ok) {
        this.$message.success('全部成功')
        allSuccess = true
      } else if (this.uploadStaus.fail && this.uploadStaus.ok) {
        this.$message.info('部分成功')
      } else {
        this.$message.info('全部失败')
      }

      this.uploadStaus.progress = 100
      this.uploadStaus.ing = false
      this.uploadStaus.end = true
      this.failFileList = this.fileList.filter(item => item.flag === false)
      this.batchUploadFn(allSuccess)
    },
    async uploadBatch(batch) {
      const uploadPromises = batch.map(async file => {
        try {
          await this.checkMD5File(file)
          return { file, success: true } // 上传成功
        } catch (error) {
          console.warn(`Error uploading file ${file.name}:`, error)
          return { file, success: false, error } // 上传失败
        }
      })
      try {
        await Promise.all(uploadPromises)
        return true // 所有文件上传成功
      } catch (error) {
        console.warn('Error uploading batch:', error)
        return false // 有文件上传失败
      }
    },
    async checkMD5File(file) {
      function getFileExtension(filename) {
        // 使用正则表达式匹配最后一个点后面的部分
        const match = filename.match(/\.([^.]+)$/)
        return match ? match[1].toLowerCase() : null
      }
      function getFileName(filename) {
        const match = filename.match(/^(.*?)(\.[^.]+)?$/)
        return match ? match[1] : null
      }
      return new Promise(async (resolve, reject) => {
        try {
          const uploadData = {
            name: getFileName(file.name),
            size: file.size,
            fileType: getFileExtension(file.name).includes('zip') ? 'exe' : getFileExtension(file.name),
            type: nameMap[file.fileType],
            url: '',
            cover: '',
            version: 1,
            subType: 1
          }
          if (this.uploadStaus.isUploading === false) {
            reject(new Error('取消上传'))
            return
          }
          this.uploadStaus.progress = 0
          // if (!pUploadData) {
          //   await this.getVideoFrame(file, uploadData)
          // }
          const fileReader = new FileReader()
          fileReader.readAsArrayBuffer(file)
          fileReader.onload = async e => {
            const spark = new SparkMD5.ArrayBuffer()
            spark.append(e.target.result)
            const fileMD5 = spark.end()
            const response = await md5Check({ file_md5: fileMD5 })
            const resfile = response.data
            if (resfile.md5_check) {
              this.uploadFile(file, uploadData, fileMD5, resolve)
            } else if (resfile.file_info) {
              uploadData.url = resfile.file_info.file_url
              if (uploadData.type === 'image') {
                uploadData.cover = uploadData.url
              }
              await this.getVideoFrame(file, uploadData)
              this.batchFileList.push(uploadData)
              this.successNum += 1
              file.flag = true
              this.uploadStaus.ok = true
              resolve('上传成功')
            }
          }
        } catch (e) {
          reject(e)
        }
      })
    },
    async checkMD5CoverFile(file, pUploadData) {
      return new Promise(async (resolve, reject) => {
        try {
          if (this.uploadStaus.isUploading === false) {
            reject(new Error('取消上传'))
            return
          }
          const fileReader = new FileReader()
          fileReader.readAsArrayBuffer(file)
          fileReader.onload = async e => {
            const spark = new SparkMD5.ArrayBuffer()
            spark.append(e.target.result)
            const fileMD5 = spark.end()
            const response = await md5Check({ file_md5: fileMD5 })
            const resfile = response.data
            if (resfile.md5_check) {
              this.uploadFile(file, pUploadData, fileMD5, resolve, pUploadData)
            } else if (resfile.file_info) {
              pUploadData.cover = resfile.file_info.file_url
              resolve('上传成功')
            }
          }
        } catch (e) {
          reject(e)
        }
      })
    },
    uploadFile(file, uploadData, fileMD5, resolve, pUploadData) {
      const fileType = file.name.split('.')[file.name.split('.').length - 1]
      const newData = new Date().getTime() / 1000
      const _this = this
      let client
      if (localStorage.OSSExpire > newData) {
        const ossConfigData = JSON.parse(localStorage.OSSConfigData)
        this.client = client = new OSS({
          region: 'oss-cn-beijing',
          accessKeyId: ossConfigData.AccessKeyId,
          accessKeySecret: ossConfigData.AccessKeySecret,
          stsToken: ossConfigData.SecurityToken,
          bucket: 'growlib-glp-u-resources',
          secure: true
        })
      } else {
        OSSConfig().then(res => {
          this.client = client = new OSS({
            region: 'oss-cn-beijing',
            accessKeyId: res.data.Credentials.AccessKeyId,
            accessKeySecret: res.data.Credentials.AccessKeySecret,
            stsToken: res.data.Credentials.SecurityToken,
            bucket: 'growlib-glp-u-resources',
            secure: true
          })
          localStorage.OSSConfigData = JSON.stringify(res.data.Credentials)
          localStorage.OSSExpire = res.data.Credentials.Expire
          const currentTime = new Date()
          client
            .multipartUpload(
              'school-level-platform/' +
                currentTime.getFullYear() +
                (currentTime.getMonth() + 1) +
                currentTime.getDate() +
                '/' +
                fileMD5 +
                '.' +
                fileType,
              file,
              {
                // 进度回调函数  获取上传进度值
                progress: (p, checkpoint) => {
                  let complete = (p * 100) | 0
                  if (complete >= 99) {
                    complete = 99
                  }
                  if (!pUploadData) {
                    this.uploadStaus.progress = complete
                  }
                  // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
                  // tempCheckpoint = checkpoint;
                },
                partSize: 1000 * 1024, // 指定分片大小
                timeout: 120000 // 设置超时时间
              }
            )
            .then(result => {
              const baseurl = 'https://src-glp-u-resource.growlib.com'
              const spliturl = 'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com'
              const ossurl = result.res.requestUrls[0].split('?')[0]
              utilReport({
                status: 1,
                file_url: baseurl + ossurl.split(spliturl)[1],
                file_md5: fileMD5
              }).then(async res => {
                if (res.code !== 200) return
                // 封面图上传
                if (pUploadData) {
                  pUploadData.cover = baseurl + ossurl.split(spliturl)[1]
                  resolve('上传成功')
                  return
                }
                // 资源上传
                uploadData.url = baseurl + ossurl.split(spliturl)[1]
                if (uploadData.type === 'image') {
                  uploadData.cover = uploadData.url
                }
                this.batchFileList.push(uploadData)
                // this.process = 100
                // this.$emit('uploadData', this.fileList)
                if (!pUploadData) {
                  await this.getVideoFrame(file, uploadData)
                }
                _this.successNum += 1
                file.flag = true
                _this.uploadStaus.ok = true
                resolve('上传成功')
              })
            })
        })
      }
    },
    getVideoFrame(file, uploadData) {
      return new Promise((resolve, reject) => {
        if (file && file.type === 'video/mp4') {
          const videoURL = URL.createObjectURL(file)
          const video = document.createElement('video')
          video.src = videoURL
          video.addEventListener('loadeddata', () => {
            // 设置画布的宽高与视频相同
            const canvas = this.$refs.canvas
            canvas.width = video.videoWidth
            canvas.height = video.videoHeight

            // 播放视频以确保可以截取帧
            video.currentTime = 3 // 截取第一帧
          })

          video.addEventListener('seeked', () => {
            const canvas = this.$refs.canvas
            const context = canvas.getContext('2d')

            // 在画布上绘制当前视频帧
            context.drawImage(video, 0, 0, canvas.width, canvas.height)

            // 将画布内容转为图片并显示
            canvas.toBlob(async blob => {
              const file = new File([blob], '封面图.png', { type: 'image/png' })
              try {
                await this.checkMD5CoverFile(file, uploadData)
                resolve('封面图上传成功')
              } catch (error) {
                reject(error)
              }
            })
            // 释放视频 URL
            URL.revokeObjectURL(videoURL)
          })

          video.load()
          return
        }
        resolve()
      })
    },
    failureDetails() {
      this.changeMassUploadvisible(false)
      this.$refs.FailureDetails.visible = true
    },
    changeMassUploadvisible(visible) {
      this.$emit('changeMassUploadvisible', visible)
    },
    highlight() {
      this.isHighlighted = true
    },
    unhighlight() {
      this.isHighlighted = false
    },
    async handleDrop(event) {
      const files = []
      let oneFiles = []
      const readDirectory = directoryEntry => {
        return new Promise(resolve => {
          const dirReader = directoryEntry.createReader()
          dirReader.readEntries(async entries => {
            for (const entry of entries) {
              if (entry.isFile) {
                const file = await new Promise(resolve => {
                  entry.file(resolve)
                })
                files.push(file)
              } else if (entry.isDirectory) {
                await readDirectory(entry) // 递归读取子文件夹
              }
            }
            resolve()
          })
        })
      }

      const items = event.dataTransfer.items
      const promises = []
      for (let i = 0; i < items.length; i++) {
        const item = items[i].webkitGetAsEntry()
        if (item.isFile) {
          await new Promise(resolve => {
            oneFiles = [...event.dataTransfer.files].filter(file => file.type !== '')
            resolve('')
          })
        } else if (item.isDirectory) {
          promises.push(readDirectory(item)) // 处理文件夹
        }
      }

      // 等待所有文件和文件夹都被读取
      Promise.all(promises).then(() => {
        this.handleFiles({ target: { files: [...oneFiles, ...files] } })
        console.log('files ----->', files) // 这里可以安全地访问 files 数组
      })
    },
    handleFiles(event) {
      const files = event.target.files
      this.inputChange(null, files)
      // Array.from(files).forEach(this.uploadFile)
    },
    batchUploadFn(allSuccess) {
      if (this.batchFileList.length === 0) return
      batchUpload({ list: this.batchFileList }).then(res => {
        this.$emit('ok', allSuccess)
      })
    },
    stopBubbling(e) {
      console.log('e ----->', e)
      e.stopPropagation()
    }
  }
}
</script>

<style lang="less" scoped>
.upload {
  height: 200px;
  flex-direction: column;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  background: #fcfcfc;
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .loading-icon {
    animation: rotate 1s linear infinite;
    width: 26px;
    margin-bottom: 11px;
  }
}
.tip {
  margin-top: 22px;
  color: #515e7b;
  font-weight: 400;
  font-size: 12px;
  .list {
    width: 18px;
    height: 21px;
    margin-left: 12px;
  }
}
.stopBubbling {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  margin-top: 10px;
  h4 {
    font-size: 16px;
    font-weight: bold;
  }
  .success-f-clolor {
    color: #258d64;
    font-weight: 540;
  }
  .cancel {
    position: absolute;
    right: 0px;
    top: 5px;
    color: #c1c1c1 !important;
  }
  .success {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: #258d64;
    h4 {
      color: #258d64;
      margin: 11px 0 16px 0;
    }
    i {
      font-size: 28px;
    }
  }
  .warning {
    color: #ee453c;
    h4 {
      color: #ee453c;
    }
  }
  .error {
    color: #f5222d;
    h4 {
      color: #f5222d;
      font-weight: bold;
    }
  }
}
.up-model {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-weight: bold;
  p {
    margin-bottom: 0px;
    color: #000;
    letter-spacing: 3px;
    img {
      margin-bottom: 10px;
    }
  }
  .up-icon {
    width: 24px;
    height: 24px;
  }
}
</style>
